module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', {
    staticClass: "page-color"
  }, [_c('c-navbar'), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "tickets"
  }, _vm._l((_vm.tickets), function(item) {
    return _c('div', {
      key: item,
      staticClass: "ticket",
      class: [(_vm.operationType == _vm.operationTypeEnum.select || item.useable) ? 'primary' : ''],
      on: {
        "click": function($event) {
          _vm.itemClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "part-1"
    }, [_c('p', {
      staticClass: "price"
    }, [_c('sup', [_vm._v("￥")]), _vm._v("\n              " + _vm._s(item.price) + "\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "part-2"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', {
      staticClass: "desc"
    }, _vm._l((item.descs), function(desc) {
      return _c('li', {
        key: desc
      }, [_vm._v(_vm._s(desc))])
    }))]), _vm._v(" "), (_vm.operationType == _vm.operationTypeEnum.click) ? _c('div', {
      staticClass: "operation"
    }, [_vm._v("领取")]) : _vm._e(), _vm._v(" "), (_vm.operationType == _vm.operationTypeEnum.select) ? _c('div', {
      staticClass: "operation select"
    }, [(_vm.selectItem == item) ? _c('i', {
      staticClass: "weui-icon-success"
    }) : _c('i', {
      staticClass: "weui-icon-circle"
    })]) : _vm._e()])])
  }))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be014c98","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tickets/index.vue
// module id = 1069
// module chunks = 2